import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { Article } from '../types/api';

const NewsSlice = createSlice({
  name: 'newsSlice',
  initialState: {
    news: [] as Article[],
  },
  reducers: {
    addNews(state, action: PayloadAction<Article[]>) {
      state.news = [...state.news, ...action.payload];
    },
    replaceNews(state, action: PayloadAction<Article[]>) {
      state.news = action.payload;
    },
  },
});

export const { addNews, replaceNews } = NewsSlice.actions;
export const { actions, reducer } = NewsSlice;
export default NewsSlice.reducer;
